export const AppNavPaths = {
    ActiveEmployees: '/activeEmployees',
    AdminTool: '/adminTool',
    AssignmentConfirmation: '/confirm',
    AssignmentCalendar: '/assignmentCalendar',
    Billing: '/billing',
    BillingChargeCategory: '/billingChargeCategory',
    BillingCharge: '/billingCharge',
    BillingRate: '/billingRate',
    BillingIssues: '/billingIssues',
    CancelConfirmation: '/cancelConfirm',
    ChargeView: '/chargeView',
    ChargeType: '/chargeType',
    ChargeTypeNew: '/newChargeType',
    ChargeTypes: '/chargeTypes',
    ChargeTypeUnits: '/chargeTypeUnit',
    ChargeTypeGroup: '/chargeTypeGroup',
    ChargeTypeGroupNew: '/newChargeTypeGroup',
    ChargeTypeGroups: '/chargeTypeGroups',
    Companies: '/companies',
    CollectedReporting: '/collectedReporting',
    Company: '/company',
    CompanyTypes: '/companyType',
    CompanyBillingGroup: '/companyBillingGroup',
    CompanyBillingGroupNew: '/companyBillingGroupNew',
    Crew: '/crew',
    Division: '/division',
    PaySchedule: '/paySchedule',
    PayScheduleNew: '/payScheduleNew',
    ComplianceType: '/complianceType',
    ComplianceTypeNew: '/complianceType?new=true',
    Contacts: '/contacts',
    Contract: '/contract',
    ContactActivities: '/contactActivities',
    ContractNew: '/newContract',
    Contracts: '/contracts',
    ContractStatuses: '/contractStatus',
    ContractTemplate: '/contractTemplate',
    ContractTemplateIndex: '/contractTemplates',
    ContractTemplateNew: '/newContractTemplate',
    CrewTimesheet: '/crewTimesheet',
    DailyAttendanceEvents: '/dailyAttendanceEvents',
    EmployeeDailyRoster: '/roster',
    Dispatch: '/dispatch',
    Employee: '/employee',
    EmployeeCompliances: '/employeeCompliances',
    LongTermStatuses: '/longTermStatuses',
    EmployeeNew: '/newEmployee',
    EmployeeNewHire: '/newEmployee?newHire=true',
    EmployeeAccountStatuses: '/employeeAccountStatus',
    Employees: '/employees',
    EmployeeTimesheets: '/myTimesheets',
    Equipment: '/equipment',
    EquipmentCompliances: '/equipmentCompliances',
    EquipmentStatuses: '/equipmentStatuses',
    EquipmentTypes: '/equipmentTypes',
    EquipmentGroups: '/equipmentGroups',
    EquipmentTypeStatuses: '/equipmentTypeStatuses',
    Group: '/group',
    Groups: '/groups',
    GroupNew: '/newGroup',
    Imports: '/imports',
    Invoice: '/invoice',
    InvoiceGeneration: '/invoiceGeneration',
    NotFound: '/notFound',
    NoPermission: '/noPermission',
    Unauthorized: '/unauthorized',
    UserGroup: '/userGroup',
    UserGroups: '/userGroups',
    UserGroupNew: '/newUserGroup',
    Role: '/role',
    Roles: '/roles',
    RoleNew: '/newRole',
    Permission: '/permission',
    Permissions: '/permissions',
    PermissionNew: '/newPermission',
    Holidays: '/holidays',
    Job: '/job',
    JobNew: '/newJob',
    JobNewForLongTermSchedule: '/newJobsForLongTermSchedule',
    JobView: '/jobView',
    Jobs: '/jobs',
    JobAssignmentCancellationTypes: '/jobAssignmentCancellationTypes',
    LongTermScheduleCalendar: '/longTermScheduleCalendar',
    Organization: '/organization',
    OrganizationNew: '/newOrganization',
    Organizations: '/organizations',
    LocationTypes: '/locationTypes',
    NotificationFailures: '/notificationFailures',
    Payroll: '/payroll',
    PayrollIndividual: '/payrollIndividual',
    QuickBooksInventoryItems: '/quickBooksInventoryItems',
    QuickBooksInventoryItem: '/quickBooksInventoryItem',
    QuickBooksInventoryItemNew: '/quickBooksInventoryItem/new',
    SelfDispatchTimesheet: '/sdtimesheet',
    SelfDispatchTimesheets: '/sdtimesheets',
    SelfDispatchTimesheetNew: '/sdtimesheetNew',
    NonFlaggingTimesheet: '/nonFlagTimesheet',
    NonFlaggingTimesheetNew: '/nonFlagTimesheetNew',
    ServerError: '/servererror',
    PayrollManagement: '/payrollManagement',
    Tenant: '/tenant',
    Tenants: '/tenants',
    TimeCharges: '/timecharges',
    TimeOffRequests: '/timeoff',
    TimeOffRequest: '/timeoffrequest',
    Timesheet: '/timesheet',
    TimesheetManagement: '/timesheetManagement',
    TimeSheetDashboard: '/timesheetDashboard',
    USCountyGroups: '/countyGroups',
    USCountyGroupNew: '/countyGroup/new',
    USCountyGroup: '/countyGroup',
    LowboyDispatchBoard: '/lowboyDispatch',
    LowboyAssignments: '/lowboyAssignments',
    LowboyAssignment: '/lowboyAssignment',
    LowboyTimesheet: '/lowboyTimesheet',
    DailyTimesheet: '/dailyTimesheet',
};
